// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Kg","play":"Lg"};